export default "__VITE_ASSET__3b8c2204__"